import styled from 'styled-components';

export const TotalClinical = styled.div``;
export const FilterBox = styled.div`
  display: flex;
  color: #8e899f;
`;
export const FilterItem = styled.div`
  display: flex;
  border: 0.1rem solid #2e2b36;
  gap: 0.3rem;
  padding: 0.5rem 1.2rem 0.5rem 0.8rem;
  border-radius: 1.4rem;
`;
export const MiddleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.6rem;
`;

export const ClinicalDataWrap = styled.div`
  width: 100%;
  display: flex;
  margin-top: 2rem;
  margin-bottom: 4rem;
  flex-direction: column;
  gap: 1.2rem;
`;
export const ClinicalDataCard = styled.div`
  width: 100%;
  padding: 1.6rem 1.2rem 2rem 1.2rem;
  background-color: #1f1e25;
  border-radius: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`;
export const Container = styled.div`
  padding: 0 2rem 5rem 2rem;
`;

export const HighlightTag = styled.div`
  padding: 0.2rem 0.8rem 0.2rem 0.6rem;
  display: flex;
  gap: 0.2rem;
  background-color: #18171c;
  border-radius: 2.2rem;
  color: #ff8ac2;
  font-size: 1.2rem;
`;

export const Tags = styled.div`
  display: flex;
`;

export const LectureName = styled.div`
  color: #9170f2;
  font-size: 1.2rem;
  padding: 0.2rem 0.8rem;
  background-color: #18171c;
  border-radius: 2.2rem;
`;

export const NameWrap = styled.div`
  display: flex;
  gap: 0.8rem;
  padding-left: 0.4rem;
  align-items: center;
`;

export const CheckBox = styled.div`
  background-color: #2e2b36;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
`;

export const MemberInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Line = styled.div`
  width: 100%;
  height: 1.2rem;
  border-top: 0.1rem solid #24222a;
`;

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  padding: 0 0.8rem;
  gap: 0.6rem;
  font-size: 1.2rem;
`;

export const Label = styled.p`
  width: 8rem;
  color: #5c576b;
`;
export const Content = styled.p`
  width: 100%;
  color: #c9c7d1;
`;

export const LabelBox = styled.div`
  display: flex;
  gap: 2.4rem;
`;

export const TagsBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonBox = styled.div`
  position: fixed;
  width: 100%;
  max-width: 50rem;
  bottom: 0;
  padding: 1.2rem 2rem 2rem 2rem;
`;
